import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';

import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
} from '@mui/material';

import { Menu as MenuIcon } from '@mui/icons-material';

import NavbarUserDropdown from './NavbarUserDropdown';
import NotificationsBell from './NotificationsBell';
import GlobalSearch from './GlobalSearch';
import MimicSelector from './MimicSelector';
import useAuth from '../../hooks/useAuth';
import { getRealUserRole, ROLES } from '../../utils/jwt';

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Navbar = ({ onDrawerToggle }) => {
  const { isAuthenticated, userMe } = useAuth();
  const isInternal =
    isAuthenticated &&
    [ROLES.ADMIN, ROLES.SALESPERSON, ROLES.PRODUCTION].includes(userMe);
  const isAdmin = isAuthenticated && getRealUserRole() === ROLES.ADMIN;

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center" spacing={1}>
          <Grid item sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={onDrawerToggle}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </Grid>
          {isInternal && (
            <Grid item sx={{ ml: 4, display: { xs: 'none', md: 'block' } }}>
              <GlobalSearch />
            </Grid>
          )}
          <Grid item xs />
          {isAdmin && (
            <Grid item sx={{ display: { xs: 'none', md: 'block' } }}>
              <MimicSelector />
            </Grid>
          )}
          {isAuthenticated && (
            <Grid item>
              <NotificationsBell />
            </Grid>
          )}
          <Grid item>
            <NavbarUserDropdown />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default withTheme(Navbar);
